export function isEcommercePreviewReadOnly(): boolean {
  return process.env.NEXT_PUBLIC_ECOMMERCE_PREVIEW_READ_ONLY === "true";
}
